import { gql } from '@apollo/client'
import { SUBCATEGORIES_QUERY } from '../graphql'
import { FIELD_ID } from '../components/CustomCode/ItProjects/itprojects_constants'
import { makeInteger } from '../utils'

const SUBCATEGORIES = gql(SUBCATEGORIES_QUERY)

const hooks = {
  subcategory_choice_hook: async function subcategory_choice_hook(field, object, parentObjectId, allInputs) {
    console.log('hooks.subcategory_choice_hook', field, object, parentObjectId, allInputs)
    let choices = []
    switch (makeInteger(field.id)) {
      case FIELD_ID.ticket.subcategory:
        const categoryId = allInputs[FIELD_ID.ticket.category].currentValue.id
        const results = await window.apolloClient.query({ query: SUBCATEGORIES, variables: { categoryId: categoryId } })
        console.log('hooks.subcatory_choice_hook', results)
        choices = results.data.subcategories
        break
      default:
        console.log(`hooks.choice_hook field "${field.name}" not handled.`)
    }
    return choices
  }
}

export default hooks
